<template>
  <base-section
    id="program-committee"
  >
  <v-container>
    <base-section-heading
    title="Program Committee"
    color="secondary"
    align="left"
    :toColor="true"
    >
    <v-row>
      <v-col
        v-for="(program, i) in programs"
        :key="i"
        cols="12"
        md="6"
      >
          {{ program.title }} - <i>{{ program.text }}</i>
      </v-col>
    </v-row>
    </base-section-heading>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'ProgramCommittee',

    data: () => ({
      isMobile: false,
      programs: [
    {
        title: "Saif Abrar",
        text: "IBM",
    },
    {
        title: "Hussam Amrouch",
        text: "Technical University of Munich (TUM)",
    },
    {
        title: "Md Tanvir Arafin",
        text: "George Mason University",
    },
    {
        title: "Daniel Arbet",
        text: "Slovak University of Technology",
    },
    {
        title: "Manuel Barragan",
        text: "TIMA",
    },
    {
        title: "Jan Belohoubek",
        text: "CTU in Prague",
    },
    {
        title: "Anna Bernasconi",
        text: "Università di Pisa",
    },
    {
        title: "Alberto Bosio",
        text: "University of Lyon",
    },
    {
        title: "Luca Cassano",
        text: "Politecnico di Milano",
    },
    {
        title: "Supriya Chakraborty",
        text: "RWTH Aachen University",
    },
    {
        title: "Anthony B. G. Coyette",
        text: "onsemi",
    },
    {
        title: "Martin Danek",
        text: "daiteq s.r.o.",
    },
    {
        title: "Stanisław Deniziak",
        text: "Kielce University of Technology",
    },
    {
        title: "Rolf Drechsler",
        text: "University of Bremen/DFKI",
    },
    {
        title: "Milos Drutarovsky",
        text: "Technical Universiity of Kosice",
    },
    {
        title: "Stephan Eggersglüß",
        text: "Siemens EDA",
    },
    {
        title: "Peeter Ellervee",
        text: "Tallinn University of Technology",
    },
    {
        title: "Goerschwin Fey",
        text: "TU Hamburg",
    },
    {
        title: "Moritz Fieback",
        text: "Delft University of Technology",
    },
    {
        title: "Petr Fiser",
        text: "Czech Technical University in Prague, FIT",
    },
    {
        title: "Tomasz Garbolino",
        text: "Silesian University of Technology",
    },
    {
        title: "Patrick Girard",
        text: "LIRMM / CNRS",
    },
    {
        title: "Jie Han",
        text: "University of Alberta",
    },
    {
        title: "Sybille Hellebrand",
        text: "Paderborn University",
    },
    {
        title: "Florian Huemer",
        text: "TU Wien",
    },
    {
        title: "Katarina Jelemenska",
        text: "FIIT STU Bratislava",
    },
    {
        title: "Maksim Jenihhin",
        text: "Tallinn University of Technology",
    },
    {
        title: "Elif Bilge Kavun",
        text: "University of Passau",
    },
    {
        title: "Martin Keim",
        text: "Siemens Digital Industries Software",
    },
    {
        title: "Oliver Keszöcze",
        text: "Technical University of Denmark",
    },
    {
        title: "Milos Krstic",
        text: "IHP",
    },
    {
        title: "Hana Kubatova",
        text: "CTU in Prague",
    },
    {
        title: "Erik Larsson",
        text: "Lund University",
    },
    {
        title: "Gildas Leger",
        text: "CSIC",
    },
    {
        title: "Regis Leveugle",
        text: "Grenoble INP",
    },
    {
        title: "Jose Machado da Silva",
        text: "INESC TEC / Univ of Porto",
    },
    {
        title: "Paolo Maistri",
        text: "TIMA Laboratory",
    },
    {
        title: "Liviu-Cristian Miclea",
        text: "Technical University of Cluj-Napoca",
    },
    {
        title: "Salvador MIR",
        text: "TIMA, CNRS, Univ Grenoble Alpes",
    },
    {
        title: "Lukas Nagy",
        text: "Slovak University of Technology",
    },
    {
        title: "Samuel Pagliarini",
        text: "Tallinn University of Technology",
    },
    {
        title: "Zebo Peng",
        text: "Linkoping University",
    },
    {
        title: "Laurence Pierre",
        text: "University Grenoble Alpes",
    },
    {
        title: "Ilia Polian",
        text: "University of Stuttgart",
    },
    {
        title: "Thomas Polzer",
        text: "UAS Technikum Wien",
    },
    {
        title: "Michele Portolan",
        text: "INP Grenoble",
    },
    {
        title: "Paolo Prinetto",
        text: "Politecnico di Torino",
    },
    {
        title: "Jaan Raik",
        text: "Tallinn University of Technology",
    },
    {
        title: "Mariusz Rawski",
        text: "Warsaw University of Technology",
    },
    {
        title: "Francesco Regazzoni",
        text: "University of Amsterdam and Università della Svizzera italiana",
    },
    {
        title: "Richard Ruzicka",
        text: "Brno University of Technology",
    },
    {
        title: "Ernesto Sanchez",
        text: "Politecnico di Torino",
    },
    {
        title: "Sebastian M. Sattler",
        text: "Friedrich-Alexander-University Erlangen-Nuremberg",
    },
    {
        title: "Kerstin Schneider-Hornstein",
        text: "TU Wien",
    },
    {
        title: "Mario Schölzel",
        text: "University of Applied Science Nordhausen",
    },
    {
        title: "Jean-Pierre Seifert",
        text: "TU Berlin",
    },
    {
        title: "Lukas Sekanina",
        text: "Brno University of Technology",
    },
    {
        title: "Pawel Sitek",
        text: "Kielce University of Technology",
    },
    {
        title: "Matteo Sonza",
        text: "Reorda Politecnico di Torino",
    },
    {
        title: "Janusz Sosnowski",
        text: "Warsaw University of Technology",
    },
    {
        title: "Roman Šotner",
        text: "Brno University of Technology",
    },
    {
        title: "Zoran Stamenkovic",
        text: "IHP - Leibniz-Institut für innovative Mikroelektronik",
    },
    {
        title: "Andreas Steininger",
        text: "TU Wien",
    },
    {
        title: "Viera Stopjakova",
        text: "Slovak University of Technology",
    },
    {
        title: "Marcello Traiola",
        text: "Inria Rennes / IRISA Lab",
    },
    {
        title: "Mihai Udrescu",
        text: "University Politehnica of Timisoara",
    },
    {
        title: "Markus Ulbricht",
        text: "IHP",
    },
    {
        title: "Fabian Luis Vargas",
        text: "IHP – Leibniz Institute for High Performance Microelectronics",
    },
    {
        title: "Elena Ioana Vatajelu",
        text: "TIMA/CNRS de Grenoble-Alpes",
    },
    {
        title: "Thibault Vayssade",
        text: "LIRMM, CNRS, Univ Montpellier",
    },
    {
        title: "Diego Vazquez",
        text: "Instituto de Microelectr¢nica de Sevilla / Universidad de Sevilla",
    },
    {
        title: "Tiziano Villa",
        text: "University of Verona",
    },
    {
        title: "Arnaud Virazel",
        text: "LIRMM",
    },
    {
        title: "Jo Vliegen",
        text: "KU Leuven",
    },
    {
        title: "Hans-Joachim",
        text: "Wunderlich University of Stuttgart",
    },
    ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
